import { API_BASE_URL } from './api';

/**
 * Fetch Style.re deliveries list
 */
export const getDoorDashDeliveries = async (): Promise<any[]> => {
  const response = await fetch(`${API_BASE_URL}/api/doordash/deliveries`, {
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch Style.re deliveries: ${response.status}`);
  }
  return response.json();
};

/**
 * Fetch Style.re delivery details by order pickup MongoDB _id
 */
export const getDoorDashDeliveryByOrderId = async (orderPickupId: string): Promise<any> => {
  const response = await fetch(`${API_BASE_URL}/api/doordash/deliveries/order/${orderPickupId}`, {
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error(`Failed to fetch Style.re delivery for orderPickupId ${orderPickupId}: ${response.status}`);
  }
  return response.json();
};

/**
 * Create a new Style.re delivery
 */
export async function createDoorDashDelivery(deliveryData: any): Promise<any> {
  const response = await fetch(`${API_BASE_URL}/api/doordash/deliveries`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(deliveryData),
  });
  if (!response.ok) {
    throw new Error(`Failed to create Style.re delivery: ${response.status}`);
  }
  return response.json();
}
